import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconNewLabelSvg } from "./IconNewLabelSvg.mjs";
const IconNewLabel = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconNewLabelSvg, ...iconProps });
};
export {
  IconNewLabel
};
